<template>
  <b-card>

    <b-row>
      <b-col class="float-right" cols="12" md="12">
        <b-button class="m-1" variant="primarySpore" @click="back()">{{$t('Labels.Back')}}</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="float-right" cols="12" md="12">
        <feather-icon v-b-tooltip.hover.left title="Editar" icon="EditIcon" @click="edit = true" class="float-right cursor-pointer" svgClasses="hover:text-primary" v-if="!edit" />
      </b-col>
    </b-row>

    <div v-if="!edit">
      <b-row class="m-2">
        <b-col cols="12" md="3" class="p-1">
          <h4>Tipo de Servicio: </h4> {{response.serviceType}}
        </b-col>
        <b-col cols="12" md="3" class="p-1">
          <h4>Período de Arrendamiento: </h4> {{response.leasePeriod}}
        </b-col>
        <b-col cols="12" md="3" class="p-1">
          <h4>Compañia: </h4> {{response.company}}
        </b-col>
      </b-row>
      <b-row class="m-2">
        <b-col cols="12" md="3" class="p-1">
          <h4>Compañia de Seguro: </h4> {{response.insuranceCompany}}
        </b-col>
        <b-col cols="12" md="3" class="p-1">
          <h4>Poliza de Seguro: </h4> {{response.policy}}
        </b-col>
        <b-col cols="12" md="3" class="p-1">
          <h4>Número: </h4> {{response.number}}
        </b-col>
        <b-col cols="12" md="3" class="p-1">
          <h4>Placas: </h4> {{response.plates}}
        </b-col>
      </b-row>
      <b-row class="m-2">
        <b-col v-if="response.cfeTeam" cols="12" md="3" class="p-1">
          <h4>Cuadrilla: </h4> {{response.cfeTeam.name}}
        </b-col>
        <b-col cols="12" md="3" class="p-1">
          <h4>Conductor: </h4> {{response.driver}}
        </b-col>
        <b-col cols="12" md="3" class="p-1">
          <h4>Teléfono conductor: </h4> {{response.driverPhone}}
        </b-col>
      </b-row>
    </div>

    <b-form class="m-2" v-if="show">
      <validation-observer ref="userValidation">
      <b-row v-if="edit === true">
        <b-col cols="12" md="3">
          <b-form-group label="Tipo de Servicio" label-for="serviceType">
            <b-form-input id="serviceType" v-model="response.serviceType" trim></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Período de Arrendamiento" label-for="leasePeriod">
            <b-form-input id="leasePeriod" v-model="response.leasePeriod" trim></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Compañia" label-for="company">
            <b-form-input id="company" v-model="response.company" trim></b-form-input>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="edit === true">
        <b-col cols="12" md="3">
          <b-form-group label="Compañia de Seguro" label-for="insuranceCompany">
            <b-form-input id="insuranceCompany" v-model="response.insuranceCompany" trim></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Poliza de Seguro" label-for="policy">
            <b-form-input id="policy" v-model="response.policy" trim></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Número" label-for="number">
            <b-form-input id="number" v-model="response.number" trim></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Placas" label-for="plates">
            <b-form-input id="plates" v-model="response.plates" trim></b-form-input>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="edit === true">
        <b-col v-if="response.cfeTeam" cols="12" md="3">
          <b-form-group label="Cuadrilla" label-for="cfeTeam" >
            <v-select input-id="cfeTeam" :options="listTeams" :clearable="false" v-model="selectedTeam" v-if="listTeams"
            placeholder="Seleccionar Cuadrilla"/>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Conductor" label-for="driver">
            <b-form-input id="driver" v-model="response.driver" trim></b-form-input>
            </b-form-group>
        </b-col>
         <b-col cols="12" md="3">
          <b-form-group label="Teléfono conductor" label-for="driverPhone">
            <validation-provider #default="{ errors }" name="driverPhone" rules="required|digits:10">
            <cleave class="form-control" id="driverPhone" v-model="response.driverPhone" :state="errors.length > 0 ? false:null" name="driverPhone" :options="options.phoneMask" placeholder="Teléfono"/>
            <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      </validation-observer>
    </b-form>

    <!-- Action Buttons -->
    <div v-if="edit">
      <b-button type="submit" class="m-1" variant="primarySpore" @click="save()">{{$t('Labels.Save')}}</b-button>
      <b-button type="reset" class="m-1" variant="outline-danger" @click="cancel()">{{$t('Labels.Cancel')}}</b-button>
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */

import {
  BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput, VBTooltip
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import request from '@/libs/request/index'
import { app } from '@/main'
import { empty } from '@/libs/tools/helpers'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    BButton, BCard, BForm, BCol, BRow, BFormGroup, vSelect, BFormInput, Cleave, ValidationProvider, ValidationObserver
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data () {
    return {
      edit: false,
      uuid: this.$route.params.uuid,
      listTeams: [{ title: '', value: '', label: '' }],
      response: {},
      selectedTeam: {},
      show: true,
      options: {
        phoneMask: {
          blocks: [3, 3, 4],
          uppercase: true
        }
      }
    }
  },
  methods: {
    cancel () {
      this.edit = false
      this.getDetail()
    },
    back () {
      app.$router.push('/cranes')
    },
    validateEmpty () {
      if (empty(this.response.plates) || empty(this.response.number)) {
        this.$swal({
          title: this.$t('Messages.Fail'),
          text: this.$t('Messages.MissingParams'),
          icon: 'error'
        })
        return true
      }
    },
    async getDetail () {
      const params = {
        url: `/cranes/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.response = data.data.data[0]
          this.selectedTeam = {
            title: this.response.cfeTeam.name,
            value: this.response.cfeTeam.uuid,
            label: this.response.cfeTeam.name
          }
        }
      })
    },
    async getTeams () {
      const params = {
        url: '/teams/list/all',
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          for (const item of data.data.data) {
            this.listTeams.push({
              title: item.name,
              value: item.uuid,
              label: item.name
            })
          }
        }
      })
    },
    async save () {
      if (!this.validateEmpty()) {
        const params = {
          url: `/cranes/${this.uuid}`,
          method: 'PUT',
          params: {
            teamUuid: this.selectedTeam.value,
            number: this.response.number,
            plates: this.response.plates,
            company: this.response.company,
            driver: this.response.driver,
            driverPhone: this.response.driverPhone,
            insuranceCompany: this.response.insuranceCompany,
            policy: this.response.policy,
            serviceType: this.response.serviceType,
            leasePeriod: this.response.leasePeriod
          }
        }
        await request(params).then(data => {
          this.edit = false
          this.getDetail()
        })
      }
    },
    validationForm () {
      this.$refs.userValidation.validate().then(success => {
        if (success) {
          this.save()
        }
      })
    }
  },
  created () {
    this.getDetail()
    this.getTeams()
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
